<img [src]="brandingOcta" aria-hidden="true" [ngStyle]="{'width.px': width}">
